<template>
  <div class="seocontent">
    <div class="topBox">
      <h1>
        <router-link tag='a' class="huanchongZhong yuanjiao text-white" to="/article">
          雪帝资讯
        </router-link>
        /
        <i v-if="!isLoading">{{title?title:'...'}}</i>
        <i v-else class='iconfont icon-jiazai xuanzhuan' style="font-size:22px;"></i>
      </h1>
      <div class="imgBox" :style="{backgroundImage:'url('+imgpath+')'}">
        <img src="/static/images/zhanwei.jpg">
      </div>
    </div>
    <div class="main yuanjiao" style="color:#000000;">
      <p class="text-right"><i>— 雪帝数字音频</i></p>
      <br>
      <div class="articleContentBox">
        <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan' style="font-size:22px;"></i>
        <span v-html="content?content:'暂无内容...'"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/util/eventBus'; // 引入事件总线
import resultCommons from '@/util/resultcommons';

export default {
  name: 'seocontent',
  props:['id'],
  data () {
    return {
      // 分页
      title: '',
      content: '',
      imgpath: '',
      isLoading: true
    }
  },
  created() {
    EventBus.$emit('globalLoadingFun', { bool: true,loading:true });
    resultCommons.apiArticleinfo(this, {id:this.id}).then((ob) => {
      if(ob.state === 200){
        this.title = ob.data.title;
        this.content = ob.data.content;
        this.imgpath = ob.data.imgpath;
      }else{
        this.$message.showMsgBox({
          type: 'warning',
          content: ob.message
        });
      }
      this.isLoading = false;
      EventBus.$emit('globalLoadingFun', { bool: false,loading:false });
    });
  },
  components:{
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  },
  mounted() {
    $('html').removeClass('scrollHide');
  }
}
</script>
<style scoped lang='less'>
  div.seocontent{
    div.topBox{
      margin-top: 100px;
      display: flex;
      h1{
        flex: 1;
        color: #FFFFFF;
        i{
          color: rgba(255,255,255,0.5);
        }
        .fubiaoti{
          color: rgba(255,255,255,0.5);
        }
      }
      div.imgBox{
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        border-radius: 5px;
        overflow: hidden;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: #1E222E;
        background-image: url("/static/images/zhanweiLoad.jpg");
        img{
          height: 250px;
          opacity: 0;
        }
      }
    }
    div.main{
      min-height: 50vh;
      margin-top: 30px;
      box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
      padding: 40px;
      color: #000000;
      background:#FFFFFF;
    }
  }
  @media (max-width: 992px) {
    div.seocontent{
      div.topBox{
        div.imgBox{
          display: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/article/Content.vue